<template>
  <div data-component-group="filter-forms" data-component="banner">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        :placeholder="$t('dates_placeholder')"
        :config="dateConfig"
        :on-change="onChangeDate"
      />

      <v-autocomplete
        clearable
        v-model="status"
        :items="statuses"
        prepend-inner-icon="download_done"
        item-title="name"
        item-value="id"
        :label="$t('status')"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import stringEscape from 'js-string-escape';
  import FiltersForm from './FiltersBase';
  import { isNull } from '@/utils'

  // TODO: Translate component

  export default {
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        search: '',
        dates: '',
        status: null,
        dateConfig: {
          mode: 'range',
        },
        selectedCountries: []
      };
    },
    created() {
      this.getStatuses();
    },
    computed: {
      hasFilters() {
        const {
          search,
          dates,
          status,
          selectedCountries
        } = this;

        return search !== '' ||
          dates !== '' ||
          status !== null ||
          selectedCountries.length > 0;
      },
      statuses() {
        return this.$store.getters['siteMessages/statuses'];
      },
    },
    methods: {
      onChangeDate(dates) {
        this.dates = dates;
      },
      onFilter() {
        const {
          search,
          dates,
          selectedCountries,
          status,
        } = this;
        const formattedSearch = isNull(search) ? '' : stringEscape(search);

        this.$emit('filter', {
          search: formattedSearch,
          dates,
          countries: selectedCountries,
          status,
        });
      },
      onClearFilters() {
        this.search = '';
        this.dates = '';
        this.selectedCountries = [];
        this.status = null;

        this.$emit('clearFilters');
      },
      getStatuses() {
        return this.$store.dispatch('siteMessages/getStatuses');
      },
    },
  };
</script>

<style lang="scss" scoped>
[data-component-group='filter-forms'] {
  &[data-component='banner'] {
    h1 {
      display: flex;
      align-items: center;
      margin: 0 0 32px 0;
      min-height: 48px;
    }
  }
}
</style>
